import { ExternalLink, HeartHandshake } from "lucide-react";

export const CapReferral = () => (
  <section className="pp-card pp-referral mt-8" data-testid="cap-referral">
    <HeartHandshake className="h-7 w-7 shrink-0" />
    <div>
      <p className="pp-label">For parents</p>
      <h2 className="pp-h2">Want more help with bullying, friendships and relationships?</h2>
      <p className="opacity-80 mt-1">Colorful Acorn Parenting™ offers deeper guidance for families, available through BurrHaus Counseling.</p>
      <a href="https://www.BurrhausCounseling.com" target="_blank" rel="noopener noreferrer" className="pp-ghost mt-3" data-testid="cap-referral-link">
        <ExternalLink className="h-4 w-4" /> Visit BurrhausCounseling.com
      </a>
    </div>
  </section>
);
